module.exports = ["a","abbr","acronym","b","basefont","big","bdi","bdo","blink","button","cite","code","data","del","dfn","em","font","i","input","ins","kbd","keygen","label","mark","marquee","meter","nobr","output","progress","q","ruby","s","samp","select","small","spacer","span","strong","sub","sup","textarea","time","tt","u","var"]


//////////////////
// WEBPACK FOOTER
// ../node_modules/rehype-minify-whitespace/list.json
// module id = 1034
// module chunks = 0 1